/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {
  type CategoryFormProps,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {variables} from 'utils/constant';
import moment from 'moment';
const AfterPartyForm: React.FC<CategoryFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editCategory,
}) => {
  console.log('🚀 ~ editCategory:', editCategory);

  const [status] = useState([
    {
      id: variables.AFTER_PARTY_ACTIVE_STATUS_ID,
      name: variables.AFTER_PARTY_ACTIVE_STATUS,
    },
    {
      id: variables.AFTER_PARTY_INACTIVE_STATUS_ID,
      name: variables.AFTER_PARTY_INACTIVE_STATUS,
    },
  ]);
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: editCategory?.name !== '' ? editCategory?.name : '',
      datetime: editCategory?.datetime !== '' ? editCategory?.datetime : '',
      location: editCategory?.location !== '' ? editCategory?.location : '',
      status: editCategory?.status !== '' ? editCategory?.status : '',
      after_party_max_capacity:
        editCategory?.after_party_max_capacity !== ''
          ? editCategory?.after_party_max_capacity
          : '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Puravida party name is required'),
      datetime: Yup.string().required('Date is required'),
      status: Yup.string().required('Status is required'),
      after_party_max_capacity: Yup.number()
        .typeError('Max capacity must be a number') // Validates the input is a number
        .required('Max capacity is required')
        .min(0, 'Max capacity must be a positive number'), // Ensures it’s at least 0
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);

      try {
        const formData = {
          name: values.name,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          status: values.status,
          datetime: moment(values.datetime).format('YYYY-MM-DD HH:mm'),
          location: values.location,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editCategory?.id ? {id: editCategory?.id} : {}),
          // brand: selectedBrandOption.map((brand: any, index: number) => ({
          //   id: brand.value,
          // })),
          after_party_max_capacity: values.after_party_max_capacity,
        };

        if (typeof values?.image !== 'string') {
          (formData as any).image = values?.image;
        }
        console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editCategory?.id
            ? await ApiUtils.updateAfterParty(formData)
            : await ApiUtils.addAfterParty(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        toast.error(err);
      }
    },
  });

  // console.log(editCategory?.id, 'categoryList');
  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Puravida Party Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyName} />
              </div>
              <Form.Control
                type="text"
                id="club-name"
                placeholder="Enter Puravida Party Name"
                name="name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.name || editCategory?.name
                    ? editCategory?.name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.name) &&
                    Boolean(validation.errors.name)
                  )
                }
              />
              {Boolean(validation.touched.name) &&
              Boolean(validation.errors.name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Date & Time :</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyDateTime} />
              </div>

              <Form.Control
                type="datetime-local"
                id="datetime"
                name="datetime"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.datetime}
                isInvalid={
                  Boolean(validation.touched.datetime) &&
                  !(validation.errors.datetime == null)
                }
              />
              {Boolean(validation.touched.datetime) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.datetime as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyStatus} />
              </div>
              <Form.Select
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editCategory?.status !== '' ? editCategory?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value=" ">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.status) &&
              Boolean(validation.errors.status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">Location link</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AfterPartyLocation} />
              </div>
              <Form.Control
                type="text"
                id="location-link"
                placeholder="Enter location link"
                name="location"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.location || editCategory?.location
                    ? editCategory?.location
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.location) &&
                    Boolean(validation.errors.location)
                  )
                }
              />
              {Boolean(validation.touched.location) &&
              Boolean(validation.errors.location) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.location}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Max capacity(people)
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon
                  text={tooltipMessage.AfterPartyMaxCapacity}
                />
              </div>
              <Form.Control
                type="number"
                id="after_party_max_capacity"
                placeholder="Enter Max Capacity"
                name="after_party_max_capacity"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.after_party_max_capacity ||
                  editCategory?.after_party_max_capacity
                    ? editCategory?.after_party_max_capacity
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.after_party_max_capacity) &&
                    Boolean(validation.errors.after_party_max_capacity)
                  )
                }
              />
              {Boolean(validation.touched.after_party_max_capacity) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.after_party_max_capacity as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editCategory?.id !== undefined
                  ? 'Edit Puravida Party'
                  : 'Add Puravida Party'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AfterPartyForm;
